import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './challan-detailed.module.css'

const ChallanFailed = () => {
    const navigate = useNavigate()

    const retryPayment = () => {
        const sessionDetails = JSON.parse(sessionStorage.getItem('eChallanToken'))
        const token = sessionDetails?.token || ''
        navigate(`/challan-detailed/${token}?retry=true`)
    }

    return (
        <Fragment>
            <div className={styles['challan-paid-container']}>
                <div className={styles['challan-paid-card']}>
                    <div className="card-body">
                        <div className="mb-3">
                            <svg width="84" height="84" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <circle cx="12" cy="12" r="11" stroke="#E74C3C" strokeWidth="2" fill="rgba(231,76,60,0.08)" />
                                <path d="M8 8L16 16M16 8L8 16" stroke="#E74C3C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>

                        <h2 className="card-title text-danger">Payment Failed</h2>
                        <p>
                            For queries contact: <span>challans@invincibleocean.com</span>
                        </p>

                        <div>
                            <button className="btn btn-primary mt-4" onClick={() => retryPayment()}>
                                Retry Payment
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ChallanFailed
